var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.45,
    y: 0.45,
    width: 46.1043,
    height: 46.1,
    rx: 23.05,
    fill: "white",
    stroke: "#949494",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8945 23.4988H31.1082",
    stroke: "#808080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCircleIcon);
export default __webpack_public_path__ + "static/media/RemoveCircleIcon.ab520deb1b189a6b8ebfcb80c8c9838f.svg";
export { ForwardRef as ReactComponent };